<!--
  Um formulário de dados da implantação (pessoais, da unidade ou bancários), montado a partir
  de camposDosDados.ts. Só edita os valores: gravar e enviar são com quem usa. Os obrigatórios
  vazios ficam marcados depois da primeira tentativa de envio (`mostrarFaltando`).
-->
<template>
  <div class="formulario" :data-testid="`formulario-${formulario}`">
    <div v-for="c in CAMPOS[formulario]" :key="c.campo" class="campo" :class="{ 'campo--largo': c.largo, 'campo--falta': mostrarFaltando && falta(c.campo) }">
      <input-date v-if="c.tipo === 'data'" :model-value="modelValue[c.campo] ?? ''" :elem-id="`${formulario}-${c.campo}`" :data-testid="`${formulario}-${c.campo}`"
                  :label="rotulo(c)" @update:model-value="mudar(c.campo, $event)" />
      <select-list v-else-if="c.tipo === 'opcoes'" :model-value="modelValue[c.campo] ?? ''" :elem-id="`${formulario}-${c.campo}`" :data-testid="`${formulario}-${c.campo}`"
                   :itens-select="(c.opcoes ?? []).map((o) => ({ ID: o.ID, Name: t(o.Name) }))" :label="rotulo(c)" @update:model-value="mudar(c.campo, $event)" />
      <input-text v-else :model-value="modelValue[c.campo] ?? ''" :elem-id="`${formulario}-${c.campo}`" :data-testid="`${formulario}-${c.campo}`"
                  :label="rotulo(c)" @update:model-value="mudar(c.campo, $event)" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import InputText from '../../inputs/InputText.vue';
import InputDate from '../../inputs/InputDate.vue';
import SelectList from '../../inputs/SelectList.vue';
import { CAMPOS, faltando, type CampoDoFormulario, type Formulario, type Valores } from './camposDosDados';

const props = withDefaults(defineProps<{ formulario: Formulario; modelValue: Valores; mostrarFaltando?: boolean }>(), { mostrarFaltando: false });
const emit = defineEmits<{ 'update:modelValue': [Valores] }>();
const { t } = useI18n();

const vazios = computed(() => new Set(faltando(props.formulario, props.modelValue)));
const falta = (campo: string): boolean => vazios.value.has(campo);
const rotulo = (c: CampoDoFormulario): string => t(c.rotulo) + (c.obrigatorio ? ' *' : '');
const mudar = (campo: string, valor: unknown): void => {
  emit('update:modelValue', { ...props.modelValue, [campo]: valor === null || valor === undefined ? null : String(valor) });
};
</script>

<style scoped>
.formulario { display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 12px 14px; }
.campo--largo { grid-column: 1 / -1; }
.campo--falta :deep(label) { color: #b42318; }
.campo--falta :deep(input) { box-shadow: 0 0 0 2px #b42318; }
</style>
